/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 新增或修改会员信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  cuUser: member.CuUser,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.CuUser;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "patch",
    url: `/member/member`,
    data: cuUser,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
